import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';

import { NewsEventProvider } from './domain/events/news-event.provider';
import { NewsCommands } from './domain/news-commands';
import { NewsRepository } from './repositories/news-repository';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [NewsRepository, NewsCommands],
})
export class NewsModule {
  static forRoot(): ModuleWithProviders<NewsModule> {
    return {
      ngModule: NewsModule,
      providers: [
        {
          provide: NewsEventProvider,
        },
      ],
    };
  }
}
